// Todo: Rewrite as ts

import {createLogger} from '~/shared/logging';

import createInstance from './http.interceptors';

const logger = createLogger('http');

const axiosInstance = createInstance();

export async function makeRequest({url, method, headers, params, timeout = 30000, convertParams = true}) {
  try {
    const response = await axiosInstance.request({
      url,
      method,
      [method === 'post' ? 'data' : 'params']: params,
      timeout,
      headers,
      convertParams,
    });

    return response.data;
  } catch (error) {
    // The rejection is handled upstream (API error states / retries), so this is a
    // handled/transient failure, not an app error. Kept at warn for a breadcrumb;
    // dropped from Sentry Logs egress via sentryLogIgnoreList to avoid per-request noise.
    logger.warn('request error', {
      url,
      method,
      params,
      message: error?.message,
      status: error?.status,
      data: error?.data,
    });
    return Promise.reject(error);
  }
}
